import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
    }}>
      <h1 style={{ fontSize: '6rem', marginBottom: '1rem', color: 'var(--primary)' }}>
        404
      </h1>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: 'var(--foreground)' }}>
        Page Not Found
      </h2>
      <p style={{ fontSize: '1.125rem', color: 'var(--muted-foreground)', marginBottom: '2rem' }}>
        The page you're looking for doesn't exist.
      </p>
      <Link
        to="/workspace"
        style={{
          padding: '0.75rem 2rem',
          background: 'linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%)',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '0.5rem',
          fontWeight: 600,
        }}
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
